<ngx-loading-bar [fixed]="true"></ngx-loading-bar>
<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>
<app-update-notification></app-update-notification>
